export default __webpack_public_path__ + "static/media/repayIconDark.bc67e765.svg";